export const BUTTON_BLACK_LARGE = 'black-large'
export const BUTTON_BLACK_MEDIUM = 'black-medium'
export const BUTTON_BLUE_LARGE = 'blue-large'
export const BUTTON_BLUE_MEDIUM = 'blue-medium'
export const BUTTON_RED_MEDIUM = 'red-medium'
export const BUTTON_BLUE_MEDIUM_ITALIC = 'blue-medium-italic'
export const BUTTON_BLUE_SMALL = 'blue-small'
export const BUTTON_RED_SMALL = 'red-small'
export const BUTTON_EMPTY = 'empty'
export const BUTTON_TRANSPARENT_MEDIUM = 'transparent-medium'
export const BUTTON_STROKE_MEDIUM = 'stroke-medium'
export const BUTTON_TRANSPARENT_LARGE = 'transparent-large'
export const BUTTON_TRANSPARENT_SMALL = 'transparent-small'
export const BUTTON_TRANSPARENT_BLUE_MEDIUM = 'transparent-blue-medium'
export const BUTTON_TRANSPARENT_BLUE_SMALL = 'transparent-blue-small'
export const BUTTON_TRANSPARENT_RED_SMALL = 'transparent-red-small'
export const BUTTON_TRANSPARENT_BLUE_VERY_SMALL = 'transparent-blue-very-small'
export const BUTTON_TRANSPARENT_LARGE_BOLD_ITALIC = 'transparent-large-bold-italic'
export const BUTTON_TRANSPARENT_SMALL_ITALIC = 'transparent-small-italic'
export const BUTTON_WITH_ICON = 'icon'
export const BUTTON_STROKE_VERY_SMALL = 'gray-very-small'
export const BUTTON_LINK = 'link'
export const BUTTON_WHITE_MEDIUM = 'white-medium'
